class SumReducer {
  initialValue() {
    return 0;
  }

  reduce(result, value) {
    return result + value;
  }
}

export default SumReducer;